'use client';

import { datadogRum } from '@datadog/browser-rum';

const envName = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME;
// 10% prod, 100% stage
const sessionSampleRate = envName === 'prod' ? 10 : 100;

datadogRum.init({
  applicationId: '7b34a930-b535-425a-92c4-f8ad5ae22351',
  clientToken: 'pubfe9cb849b335b1656588330958f31d3a',
  site: 'datadoghq.com',
  service: 'content',
  env: envName,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate,
  sessionReplaySampleRate: 0,
  defaultPrivacyLevel: 'mask-user-input',
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
